import en from './en';
import zh from './zh';
import es from './es';
import hi from './hi';
import ar from './ar';
import fr from './fr';
import pt from './pt';
import id from './id';
import bn from './bn';
import de from './de';
import ja from './ja';
import ko from './ko';
import tr from './tr';

const locales = {
    en,
    zh,
    es,
    hi,
    ar,
    fr,
    pt,
    id,
    bn,
    de,
    ja,
    ko,
    tr,
};

export const languageOptions = [
    { code: "en", label: "English" },
    { code: "zh", label: "中文" },
    { code: "es", label: "Español" },
    { code: "hi", label: "हिन्दी" },
    { code: "ar", label: "العربية" },
    { code: "fr", label: "Français" },
    { code: "pt", label: "Português" },
    { code: "id", label: "Bahasa Indonesia" },
    { code: "bn", label: "বাংলা" },
    { code: "de", label: "Deutsch" },
    { code: "ja", label: "日本語" },
    { code: "ko", label: "한국어" },
    { code: "tr", label: "Türkçe" },
];

export const defaultLanguage = "en";

export const getLocale = (language) => locales[language] || locales[defaultLanguage];

export default locales;
